import React from "react";
import { FaHandHoldingMedical } from "react-icons/fa6";
import { FaHeartbeat, FaLongArrowAltRight } from "react-icons/fa";
const Service = () => {
  return (
    <div className="service py-4 " id="service">
      <div className="container ">
        <div className="row ">
          <div className="row m-0 p-0 g-0 serviceHeading text-center pt-3 ">
            <h5>
              <span>
                <FaHandHoldingMedical fontSize={25} />
              </span>{" "}
              <span>Medical Service</span>
            </h5>
          </div>
          <div className="row m-0 p-0 g-0 serviceSubHeading text-center">
            <h1>
              Find Out More About <br /> Our Service
            </h1>
          </div>
          {/* all services section */}

          <div className="row m-0 p-0 g-0 ourServices">
            <div className="col-md-4 space">
              <div className="box m-1 text-center">
                <div className="row logo m-0 p-0 g-0">
                  <span>
                    <FaHeartbeat />
                  </span>
                </div>
                <div className="row m-0 p-0 heading">
                  <h5>Heading</h5>
                </div>
                <div className="row SubHeading m-0 p-0">
                  <p>
                    Lorem ipsum dolor sit amet, consectetur . Lorem ipsum dolor
                    sit amet, consectetur Lorem ipsum dolor sit
                  </p>
                </div>
                <div className="row readMore m-0 p-0">
                  <span>
                    Read More <FaLongArrowAltRight />
                  </span>
                </div>
              </div>
            </div>
            <div className="col-md-4 space">
              <div className="box m-1 text-center">
                <div className="row logo m-0 p-0 g-0">
                  <span>
                    <FaHeartbeat />
                  </span>
                </div>
                <div className="row m-0 p-0 heading">
                  <h5>Heading</h5>
                </div>
                <div className="row SubHeading m-0 p-0">
                  <p>
                    Lorem ipsum dolor sit amet, consectetur . Lorem ipsum dolor
                    sit amet, consectetur Lorem ipsum dolor sit
                  </p>
                </div>
                <div className="row readMore m-0 p-0">
                  <span>
                    Read More <FaLongArrowAltRight />
                  </span>
                </div>
              </div>
            </div>
            <div className="col-md-4 space">
              <div className="box m-1 text-center">
                <div className="row logo m-0 p-0 g-0">
                  <span>
                    <FaHeartbeat />
                  </span>
                </div>
                <div className="row m-0 p-0 heading">
                  <h5>Heading</h5>
                </div>
                <div className="row SubHeading m-0 p-0">
                  <p>
                    Lorem ipsum dolor sit amet, consectetur . Lorem ipsum dolor
                    sit amet, consectetur Lorem ipsum dolor sit
                  </p>
                </div>
                <div className="row readMore m-0 p-0">
                  <span>
                    Read More <FaLongArrowAltRight />
                  </span>
                </div>
              </div>
            </div>
            <div className="col-md-4 space">
              <div className="box m-1 text-center">
                <div className="row logo m-0 p-0 g-0">
                  <span>
                    <FaHeartbeat />
                  </span>
                </div>
                <div className="row m-0 p-0 heading">
                  <h5>Heading</h5>
                </div>
                <div className="row SubHeading m-0 p-0">
                  <p>
                    Lorem ipsum dolor sit amet, consectetur . Lorem ipsum dolor
                    sit amet, consectetur Lorem ipsum dolor sit
                  </p>
                </div>
                <div className="row readMore m-0 p-0">
                  <span>
                    Read More <FaLongArrowAltRight />
                  </span>
                </div>
              </div>
            </div>
            <div className="col-md-4 space">
              <div className="box m-1 text-center">
                <div className="row logo m-0 p-0 g-0">
                  <span>
                    <FaHeartbeat />
                  </span>
                </div>
                <div className="row m-0 p-0 heading">
                  <h5>Heading</h5>
                </div>
                <div className="row SubHeading m-0 p-0">
                  <p>
                    Lorem ipsum dolor sit amet, consectetur . Lorem ipsum dolor
                    sit amet, consectetur Lorem ipsum dolor sit
                  </p>
                </div>
                <div className="row readMore m-0 p-0">
                  <span>
                    Read More <FaLongArrowAltRight />
                  </span>
                </div>
              </div>
            </div>
            <div className="col-md-4 space">
              <div className="box m-1 text-center">
                <div className="row logo m-0 p-0 g-0">
                  <span>
                    <FaHeartbeat />
                  </span>
                </div>
                <div className="row m-0 p-0 heading">
                  <h5>Heading</h5>
                </div>
                <div className="row SubHeading m-0 p-0">
                  <p>
                    Lorem ipsum dolor sit amet, consectetur . Lorem ipsum dolor
                    sit amet, consectetur Lorem ipsum dolor sit
                  </p>
                </div>
                <div className="row readMore m-0 p-0">
                  <span>
                    Read More <FaLongArrowAltRight />
                  </span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Service;
